import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/render/project/src/node_modules/.pnpm/gatsby-theme-docz@2.3.1_@babel+core@7.11.1_@types+node@24.7.0_docz@2.4.0_@babel+core@7._04842b0c5656885ffb9b2f355e30df2b/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "plt-2251-workflow-validation-investigation"
    }}>{`PLT-2251 Workflow Validation Investigation`}</h1>
    <p><strong parentName="p">{`Date`}</strong>{`: 2026-01-26`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Scope`}</strong>{`: Builder UI workflow validation for extended user attributes`}</p>
    <h2 {...{
      "id": "what-was-reviewed"
    }}>{`What was reviewed`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`app/src/flowbot/engine/validate.jsx`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`app/src/pages-builder/workflow/index.jsx`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`app/src/flowbot/steps/notification.jsx`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`app/src/flowbot/components/email-builder.jsx`}</inlineCode></li>
    </ul>
    <h2 {...{
      "id": "findings"
    }}>{`Findings`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Step config validation is filtered`}</strong>{`: The workflow builder computes a filtered
`}<inlineCode parentName="p">{`schema`}</inlineCode>{` and passes it to step Config as `}<inlineCode parentName="p">{`fieldsAllForConfig`}</inlineCode>{`. This includes
the `}<inlineCode parentName="p">{`filterMetaSubFields`}</inlineCode>{` logic that respects `}<inlineCode parentName="p">{`selectedExtendedUserAttributes`}</inlineCode>{`,
so step-level validation (e.g., email template variables) should flag missing
references when fields are deselected.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Global workflow warnings may be unfiltered`}</strong>{`: The page-level warnings use
`}<inlineCode parentName="p">{`Flowbot.validate(data.app.dataset.workflow)`}</inlineCode>{` which relies on `}<inlineCode parentName="p">{`workflow.schema`}</inlineCode>{`
from the backend. The backend schema includes pre-expanded meta subfields and
does not appear to be filtered by `}<inlineCode parentName="p">{`selectedExtendedUserAttributes`}</inlineCode>{`, so missing
extended fields may not be flagged in the global warnings panel.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "evidence"
    }}>{`Evidence`}</h2>
    <ul>
      <li parentName="ul">{`Email template variables are validated via `}<inlineCode parentName="li">{`EmailBuilder.validate`}</inlineCode>{`, which
checks `}<inlineCode parentName="li">{`fieldsAll`}</inlineCode>{` for matching `}<inlineCode parentName="li">{`formKey`}</inlineCode>{` entries.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`fieldsAllForConfig`}</inlineCode>{` is derived from the locally filtered `}<inlineCode parentName="li">{`schema`}</inlineCode>{` in
`}<inlineCode parentName="li">{`pages-builder/workflow/index.jsx`}</inlineCode>{`, while `}<inlineCode parentName="li">{`Flowbot.validate`}</inlineCode>{` uses the backend
workflow schema.`}</li>
    </ul>
    <h2 {...{
      "id": "manual-testing"
    }}>{`Manual testing`}</h2>
    <p>{`Manual UI testing was not run in this environment. If needed, test:`}</p>
    <ol>
      <li parentName="ol">{`Add `}<inlineCode parentName="li">{`{{meta.submittedBy.extended.<section>.<field>}}`}</inlineCode>{` to a notification.`}</li>
      <li parentName="ol">{`Deselect that field in `}<inlineCode parentName="li">{`selectedExtendedUserAttributes`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`Observe:`}
        <ul parentName="li">
          <li parentName="ul">{`Step Config validation should show missing variables.`}</li>
          <li parentName="ul">{`Global warning banner may not update (potential gap).`}</li>
        </ul>
      </li>
    </ol>
    <h2 {...{
      "id": "follow-up-idea-if-needed"
    }}>{`Follow-up idea (if needed)`}</h2>
    <p>{`If global warnings should reflect the filtered schema, consider calling
`}<inlineCode parentName="p">{`Flowbot.validate`}</inlineCode>{` with the filtered `}<inlineCode parentName="p">{`schema`}</inlineCode>{` (or passing it as `}<inlineCode parentName="p">{`formSchema`}</inlineCode>{`)
instead of relying solely on the backend `}<inlineCode parentName="p">{`workflow.schema`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      